import React from 'react';
import PropTypes from 'prop-types';
import { createMemoStyles, defaultBaseline, defaultFonts, safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var useStyles = createMemoStyles(function (theme) {
  var type = theme.type,
    spacing = theme.spacing,
    palette = theme.palette;
  return {
    wrenchFormGroup: function wrenchFormGroup(_ref) {
      var inline = _ref.inline;
      return _objectSpread(_objectSpread(_objectSpread({}, defaultBaseline), defaultFonts(theme)), {}, {
        display: 'block',
        border: 'none',
        minWidth: '0',
        width: '100%',
        padding: 0,
        '& > div': {
          float: inline && 'left',
          paddingRight: inline && spacing[5]
        }
      });
    },
    wrenchFormGroupLegend: function wrenchFormGroupLegend() {
      return {
        display: 'block',
        width: 'auto',
        border: 'none',
        margin: [0, 0, spacing[1]],
        color: palette.text.dark,
        fontFamily: type.fontFamily.base,
        fontSize: type.fontSize.bodySm,
        fontWeight: type.fontWeight.medium,
        padding: 0
      };
    },
    wrenchFormField: function wrenchFormField() {
      return {
        padding: [spacing[2], 0],
        '&:last-child': {
          marginBottom: '0',
          '&:last-child': {
            paddingRight: '0'
          }
        }
      };
    }
  };
});
var _excluded$1 = ["children", "inline", "label"];
var FormGroup$1 = function FormGroup(_ref) {
  var children = _ref.children,
    inline = _ref.inline,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var theme = useTheme();
  var _useStyles = useStyles({
      inline: inline,
      theme: theme
    }),
    wrenchFormGroup = _useStyles.wrenchFormGroup,
    wrenchFormGroupLegend = _useStyles.wrenchFormGroupLegend;
  return /*#__PURE__*/React.createElement("fieldset", Object.assign({
    className: wrenchFormGroup
  }, safeRest(rest)), label ? /*#__PURE__*/React.createElement("legend", {
    className: wrenchFormGroupLegend
  }, label) : null, children);
};
FormGroup$1.displayName = "FormGroup";
FormGroup$1.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Display the child Form.Fields inline.
   */
  inline: PropTypes.bool,
  /**
   * Adds a legend element with provided text above the FormGroup.
   */
  label: PropTypes.node
};
FormGroup$1.defaultProps = {
  inline: false,
  label: null
};
var _excluded = ["children"];
var FormGroup = function FormGroup(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _useStyles = useStyles({
      theme: theme
    }),
    wrenchFormField = _useStyles.wrenchFormField;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: wrenchFormField
  }, safeRest(rest)), children);
};
FormGroup.displayName = "FormGroup";
FormGroup.propTypes = {
  children: PropTypes.node.isRequired
};
export { FormGroup as FormField, FormGroup$1 as FormGroup };